import { render, staticRenderFns } from "./portraitTopMenu.vue?vue&type=template&id=3bddfb24&scoped=true&"
import script from "./portraitTopMenu.vue?vue&type=script&lang=js&"
export * from "./portraitTopMenu.vue?vue&type=script&lang=js&"
import style0 from "./portraitTopMenu.vue?vue&type=style&index=0&id=3bddfb24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddfb24",
  null
  
)

export default component.exports